import { connect, } from 'react-redux'
import { bindActionCreators, } from 'redux'

import { addTripLocation, navViewTrip, } from 'redux/actions'
import { selectedTripId, selectedTripData, } from 'redux/reducers'
import Component from './component'

const mapStateToProps = state => ({
  tripId: selectedTripId(state),
  tripData: selectedTripData(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ addTripLocation, viewTrip: navViewTrip, }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripScene/EditTripScene/index.js